 <template>
    <div v-if="traineesArr && traineesArr.length > 0">

        <ob-popover trigger="click" style="margin-top:5px;cursor:pointer" ref="popover" :options="{placement: 'right'}">
            <div class="row poppers" v-bind:class="{'popperScroll': traineesArr.length > 5 }">
                <!-- <span class="pull-left" style="color: #c0c0c0; margin-left: 5px;font-weight:100;font-size: 12px;">TRAINEES</span> -->
                <div class="col-md-12 borderlineEnd" v-for="(trainee , index) in traineesArr" :key="index" v-bind:class="{'borderline': traineesArr.length-1 == index }">
                    <div class="col-md-2" style="padding-left:0px;paddin-top:6px;padding-left: 0px; padding-right: 3px;padding-top: 3px;">
                        <!-- <img alt="image" class="img-circle" :src="trainee.ProfilePic != null ? trainee.ProfilePic : 'static/Content/Images/noimage.svg'" style="padding-left:0px;paddin-top:6px;" /> -->
                        <img height="35" width="35" alt="image" class="img-circle" :src="trainee.ProfilePic != null && trainee.ProfilePic != '' ? trainee.ProfilePic : `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/noimage.svg`" style="padding-left:0px;paddin-top:6px;" />
                    </div>
                    <div class="col-md-10 " style="padding-left:10px;padding-right:0px;">
                        <span class="pull-left" style="color:#143361; margin-left:4px;font-weight: 700;text-align:left">{{trainee.Name}} <span v-if="trainee.IsTrainee" v-tooltip="'Trainee'" class="trainee-span">T</span></span>
                        <br>
                        <p class="pull-left" style="color:#c2c2c2;margin-left:5px;text-align:left">{{trainee.Designation}}</p>
                    </div>
                </div>
            </div>
            <div  slot="reference" style="display:inline;margin-left:6px;">

                <span  v-for="(trainee , Cindex) in traineesArr" :key="Cindex" v-if="Cindex <= 7">
                    <!-- <ob-contact-circle :circlesize="30" v-if="Cindex <= 3" :circletitle="trainee.Name" style="margin-left:-10px;border:2px solid white;border-radius:50%;"></ob-contact-circle> -->


                     <ob-contact-circle :circlesize="30" v-if="Cindex <= 6" :circletitle="trainee.Name" style="margin-left:-10px;border:2px solid white;border-radius:50%;"></ob-contact-circle>


                    <p class="circle" v-bind:class="{'circleCount': traineesArr.length > 15 }" v-else >
                    <span style="font-size:12px;color:white;">+{{traineesArr.length-7}}</span>
                </p>
                </span>
            </div>
        </ob-popover>
   </div>

    <div v-else>
        <!-- <p>N/A</p> -->
         <ob-spinner v-if="IsLoading"></ob-spinner>
    </div>
</template>

<script>
import c from 'Vue/Core/constants.js';
export default {
    name : "ReportingTraineeCircle",
    props: ['Trainees'],
    data() {
        return {
            IsLoading : true,
            traineesArr: [],
        }
    },
    computed: {

    },
    components:{
    },
    methods: {},
    watch: {
        Trainees(val)
        {
            this.traineesArr=val
        }

    },
    created() {
        this.traineesArr=this.Trainees
    }
}
</script>
<style lang="scss" scoped>
@import "~styles/framework/vue-utils";

.poppers {
    cursor: context-menu;
    // transform: translate3d(303px, 0px, 90px) !important;
    max-height: 400px !important;
    max-width: 225px;
    background-color: #fff;
    color: #212121;
    text-align: center;
    padding: 2px;
    display: inline-block;
    border-radius: 13px;
    position: absolute;
    font-size: 14px;
    font-weight: normal;
    border: 1px #ebebeb solid;
    z-index: 2 !important;
    padding: 7px;
    -webkit-box-shadow: 0 0 4px #ddd;
    box-shadow: 0 0 4px #ddd;
    overflow-y: auto;
}

.popperScroll {
    overflow-y: scroll;
    margin-right: 7px;
    max-width: 225px;
    background-color: #fff;
    color: #212121;
    text-align: left;
    padding: 2px;
    display: inline-block;
    border-radius: 13px;
    position: absolute;
    font-size: 14px;
    font-weight: normal;
    border: 1px #ebebeb solid;
    z-index: 2 !important;
    padding: 7px;
    -webkit-box-shadow: 0 0 4px #ddd;
    box-shadow: 0 0 4px #ddd;
}

.borderline {
    padding: 12px 0px 12px 5px;
    border: none !important;
}

.borderlineEnd {
    padding: 12px 0px 12px 5px;
    border-bottom: 1px solid #c2c2c2;
}

.circle {
    // height: 25px;
    // width: 25px;
    background-color: #FF6347;
    border-radius: 50%;
    display: inline;
    padding: 6px 7px;
    border: 2px solid white;
    margin-left: -8px;
    position: sticky;
    // position:absolute;
}

.circleCount {
    // height: 25px;
    // width: 25px;
    background-color: #FF6347;
    border-radius: 50%;
    display: inline;
    padding: 5px 3px;
    border: 2px solid white;
    margin-left: -8px;
    // position:absolute;
}
.trainee-span{
  background-color:#3EC1A3;
  color:white;
  font-size: 12px;
  border-radius: 10px;
  padding: 1px 6px 0px 6px;
  font-weight: 800;
  margin-left: 6px;
  z-index: 1002;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/ESSDashboard/ReportingTraineeCircle.vue